import styles from './ProviderLogo.scss';

export const PROVIDER_LOGO_MAPPING = {
  amusnet: styles.amusnet,
  'Cape Cod': styles.capeCod,
  'Core Gaming': styles.starsStudios,
  'Games Global': styles.gamesGlobal,
  gol_games: styles.golGames,
  'Light And Wonder': styles.lightAndWonder,
  'Push Gaming': styles.pushGaming,
  'RAW Gaming': styles.rawIgaming,
  'Red Tiger': styles.redTiger,
  'Relax Gaming': styles.relaxGaming,
  union: styles.union,
  authenticgaming: styles.authenticgaming,
  Blueprint: styles.bluePrintGaming,
  Bragg: styles.bragg,
  Cayetano: styles.starsStudios,
  Evolution: styles.evolutionGaming,
  flutterstudios: styles.starsStudios,
  High5: styles.high5Games,
  IGT: styles.igt,
  Ingenuity: styles.starsStudios,
  Inspired: styles.inspiredGaming,
  MGA: styles.mgaGames,
  NetEnt: styles.netent,
  Octoplay: styles.octoplay,
  Onseo: styles.starsStudios,
  PlayNGo: styles.playNGo,
  Playtech: styles.playtech,
  Pragmatic: styles.pragmaticPlay,
  Premium: styles.starsStudios,
  RubyPlay: styles.rubyPlay,
  Skywind: styles.skywind,
  subtract: styles.elkStudios,
  Thunderkick: styles.thunderkick,
  WMG: styles.wmg,
  Yggdrasil: styles.yggdrasil
};
